import React from 'react';
import { Menu, Moon, Sun } from 'lucide-react';
import AvatarMenu from '../ui/misc/AvatarMenu';
import { logoFull } from '../../assets/logos';
import { useDarkMode } from '../../context/DarkModeContext';

interface Props {
  onMenuClick?: () => void;
}

const AppTopbar: React.FC<Props> = ({ onMenuClick }) => {
  const { darkMode, toggleDarkMode } = useDarkMode();

  const handleMenuClick = () => {
    console.log('🔘 AppTopbar: Menu button clicked');
    if (onMenuClick) {
      console.log('✅ AppTopbar: Calling onMenuClick handler');
      onMenuClick();
    } else {
      console.error('❌ AppTopbar: onMenuClick is not defined!');
    }
  };

  return (
    <header className="print:hidden h-16 bg-card dark:bg-dark-card border-b border-border dark:border-dark-border shadow-sm sticky top-0 z-40 flex items-center justify-between px-6">
      <div className="flex items-center gap-3">
        {onMenuClick && (
          <button
            onClick={handleMenuClick}
            className="p-2 rounded-lg bg-ds-bg-surface border border-ds-border-default hover:bg-ds-bg-hover lg:hidden text-ds-text-secondary hover:text-ds-text-primary transition-colors shadow-sm"
            aria-label="Toggle Settings Menu"
          >
            <Menu size={20} />
          </button>
        )}
        <img src={logoFull} alt="ExpTrax" className="h-8 w-auto" />
      </div>
      
      <div className="flex items-center gap-4">
        {/* Dark Mode Toggle */}
        <button
          onClick={toggleDarkMode}
          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-dark-hover transition-all duration-200"
          aria-label="Toggle Dark Mode"
          title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        >
          {darkMode ? (
            <Sun className="w-5 h-5 text-yellow-500" />
          ) : (
            <Moon className="w-5 h-5 text-gray-600" />
          )}
        </button>
        
        <AvatarMenu />
      </div>
    </header>
  );
};

export default AppTopbar;
